import { render, staticRenderFns } from "./NavigationElement.vue?vue&type=template&id=0f1bb1da"
import script from "./NavigationElement.vue?vue&type=script&lang=js"
export * from "./NavigationElement.vue?vue&type=script&lang=js"
import style0 from "./NavigationElement.vue?vue&type=style&index=0&id=0f1bb1da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports